"use client";

import Script from "next/script";

const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID;
const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID;
const BING_UET_ID = process.env.NEXT_PUBLIC_BING_UET_ID;

/**
 * 统一注入分析埋点：GA4 / Microsoft Clarity / Bing UET。
 * 三者均通过 NEXT_PUBLIC_* 环境变量开启，未配置时该组件直接返回 null，
 * 不产生任何外部请求，也不影响首屏渲染（strategy=afterInteractive，利于 LCP/SEO）。
 *
 * 环境变量在 web/.env.example 中列出；上线后在托管平台（Vercel 等）配置即可。
 */
export default function Analytics() {
  if (!GA4_ID && !CLARITY_ID && !BING_UET_ID) return null;

  return (
    <>
      {GA4_ID && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`}
            strategy="afterInteractive"
          />
          <Script id="ga4-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA4_ID}', { anonymize_ip: true });
            `}
          </Script>
        </>
      )}

      {CLARITY_ID && (
        <Script id="ms-clarity" strategy="afterInteractive">
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window,document,"clarity","script","${CLARITY_ID}");
          `}
        </Script>
      )}

      {BING_UET_ID && (
        <Script id="bing-uet" strategy="afterInteractive">
          {`
            (function(w,d,t,r,u){
              var f,n,i;
              w[u]=w[u]||[],f=function(){
                var o={ti:"${BING_UET_ID}"};
                o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad");
              };
              n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){
                var s=this.readyState;
                s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null);
              };
              i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i);
            })(window,document,"script","//bat.bing.com/bat.js","uetq");
          `}
        </Script>
      )}
    </>
  );
}
